var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-tile',{attrs:{"edit-enabled":_vm.project.isEditModeEnabled},on:{"tile-clicked":_vm.tileClicked},scopedSlots:_vm._u([{key:"image",fn:function(){return [_c('font-awesome-icon',{staticClass:"text-black-50",attrs:{"icon":"image","size":"6x"}})]},proxy:true},{key:"line1",fn:function(){return [_c('p',[_c('font-awesome-icon',{class:[_vm.snapshot.id === _vm.$store.state.snapshot.currentSnapshot.id
          ? 'text-success'
          : 'text-black-25'
        ],attrs:{"icon":"circle"}}),_vm._v("\n      "+_vm._s(_vm.snapshot.name)+"\n    ")],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }